// Configuration constants
export const CONFIG = {
  FILTER_TYPES: {
    PROGRAM: "program",
    YEAR: "year",
    STATUS: "status",
    PURPOSE: "purposeOfVisit",
    SEARCH_TERM: "searchTerm",
    DATE_RANGE: "dateRange",
  },
  EXPORT_TYPES: { PDF: "pdf", EXCEL: "excel", CSV: "csv" },
  STATUS_OPTIONS: [
    { key: "active", text: "Active", value: "active" },
    { key: "completed", text: "Completed", value: "completed" },
  ],
  TABLE_HEADERS: [
    "User Name",
    "Library ID",
    "Program / Year",
    "Purpose of Visit",
    "Check-in Time",
    "Check-out Time",
    "Duration",
    "Status",
  ],
  INITIAL_FILTERS: {
    program: "",
    year: "",
    status: "",
    purposeOfVisit: "",
    dateRange: { start: "", end: "" },
    searchTerm: "",
  },
  PAGINATION_OPTIONS: [
    { key: 5, text: "5", value: 5 },
    { key: 10, text: "10", value: 10 },
    { key: 25, text: "25", value: 25 },
    { key: 50, text: "50", value: 50 },
  ],
};
